import { useQuery } from '@tanstack/react-query';

import TaxonomiesService from '@/services/TaxonomiesService';

const GET_ADMIN_TAXONOMY_CATEGORIES_QUERY_KEY = (
  customerId: number,
  version: string,
) => ['admin-taxonomies-categories', customerId, version];
export function useGetAdminTaxonomyCategories(
  customerId: number,
  version: string,
) {
  const { data, isFetching } = useQuery({
    queryKey: GET_ADMIN_TAXONOMY_CATEGORIES_QUERY_KEY(customerId, version),
    queryFn: () =>
      TaxonomiesService.getAdminTaxonomiesByVersion(customerId, version),
    enabled: !!version,
  });

  return {
    categories: data ?? [],
    categoriesLoading: isFetching,
  };
}
